import React, { lazy, Suspense } from "react";
import { useTranslation } from "react-i18next";
import { Route } from "react-router-dom";
// components
import Header from "../Admin/Header";
import Loader from "../common/Loader";
// utils
import { routes } from "../../utils/constants/routes";
import { Body, Container, Content } from "../../utils/css/layout";
import Footer from "../common/Footer/Footer";
import * as salonsSelector from "../../store/selectors/salonsSelectors";
import { useSelector } from "react-redux";
import {useIsMobile} from "../../utils/usIsMobile";

const HostsProfile = lazy(() => import("../Hosts/indexProfile"));
const Hosts = lazy(() => import("../Hosts/index"));
const ErrorPage = lazy(() => import("../Errors/ErrorPage"));
const GuestSalon = lazy(() => import("../Guests/GuestSalon"));
const GuestProfile = lazy(() => import("../Guests/GuestProfile"));
const salonSearch = lazy(() => import("../Guests/SalonSearch"));

const Site = () => {
  const { i18n } = useTranslation();
  const isIOSModalOpen = useSelector(salonsSelector.isIOSModalOpenSelector);
  const isMobile = useIsMobile();

  return (
    <>
      <Header />
      <Body lng={i18n.language} isIOSModalOpen={isIOSModalOpen}>
        <Container>
          <Content>
            <Suspense fallback={<Loader />}>
              <Route path={routes.hostProfile.salon} exact component={Hosts} />
              <Route
                path={routes.hostProfile.profile}
                exact
                component={HostsProfile}
              />
              <Route
                path={routes.guestProfile.salon}
                exact
                component={GuestSalon}
              />
              <Route
                path={routes.guestProfile.profile}
                exact
                component={GuestProfile}
              />
              <Route path={routes.errorPage.error} component={ErrorPage} />
              <Route path={routes.salonSearch.root} component={salonSearch} />
            </Suspense>
          </Content>
        </Container>
      </Body>
      {!isMobile && <Footer />}
       {isMobile && <Footer />}
    </>
  );
};

export default Site;
